import cogoToast from "cogo-toast"
import React, { useRef, useState } from "react"
import { Button } from "react-bootstrap"
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls"
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable"
import { errorMessage, formatDate, formatStatus } from "../../../util/Helpers"
import { ViewIcon } from "../../../util/Icons"
import { FilterGroup } from "../../Common/components/FilterGroup"
import { PendingDocumentModal } from "./modal/PendingDocumentModal"

export const PendingDocumentTable = ({ match: { params: { userGroup } } }) => {
    const tableRef = useRef();

    const [docModal, setDocModal] = useState({ showDocModal: false, data: null });

    /* Action Buttons */
    const pendingDocView = row => {
        
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Button
                    title="View Doc"
                    className="btn btn-icon btn-light btn-hover-primary btn-sm  bg-white"
                    onClick={_ => setDocModal({ showDocModal: true, data: { ...row, status: "PENDING" } })}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <ViewIcon />
                    </span>
                </Button>
            </span>
        )
    }

    return (
        <div className="py-4 px-6">
            <FilterGroup key={`pending-docs-${userGroup}`} defaultFilters={{ "sortBy": "createdAt:desc" }}>
                <FilterGroup.DateRange className={"mb-5"} />
                <FilterGroup.Content>
                    {
                        ({ filters }) => (
                            <Card>
                                <CardHeader title="Pending Documents" >
                                    <CardHeaderToolbar>
                                        <FilterGroup.Filter className={"bg-black"} width="300px" name={"sortBy"} label={"Sort"} menuAnchorRight>
                                            <FilterGroup.Option value={"createdAt:desc"}>Created At ( Descending )</FilterGroup.Option>
                                            <FilterGroup.Option value={"createdAt:asc"}>Created At ( Ascending )</FilterGroup.Option>
                                            <FilterGroup.Option value={"kycCompletion:desc"}>Completion Percentage ( Descending )</FilterGroup.Option>
                                            <FilterGroup.Option value={"kycCompletion:asc"}>Completion Percentage ( Ascending )</FilterGroup.Option>
                                        </FilterGroup.Filter>
                                    </CardHeaderToolbar>
                                </CardHeader>
                                <CardBody>
                                    <DynamicSimpleTable
                                        key={userGroup}
                                        queryParams={
                                            `startDate=${filters?.startDate || ""}`
                                            + `&endDate=${filters?.endDate || ""}`
                                            + `&sortBy=${filters?.sortBy || ""}`
                                        }
                                        source={{ url: `/pending-kyc/user-group/${userGroup}/document` }}
                                        columns={[
                                            { title: "USER", format: row => <a href={`/users/view/${row.userId}/documents`} className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" rel="noreferrer" target="_blank">{row.username}</a> },
                                            { title: "CATEGORY", key: "type" },
                                            { title: "ID TYPE", key: "idType" },
                                            { title: "SIDE", key: "side" },                                           
                                            { title: "KYC STATUS", format: row => formatStatus(row.kycStatus) },
                                            { title: "Document STATUS", format: row => formatStatus(row.status) },
                                            { title: "KYC COMPLETION", format: row => `${row.kycCompletion}%` },
                                            { title: "CREATED AT", format: row => formatDate(row.created) },
                                            { title: "", format: pendingDocView }
                                        ]}
                                        ref={tableRef}
                                        onError={err => cogoToast.error(errorMessage(err))}
                                        refreshIcon={true}
                                    />
                                </CardBody>
                            </Card>
                        )
                    }
                </FilterGroup.Content>
            </FilterGroup>
            {
                docModal.showDocModal &&
                <PendingDocumentModal details={docModal.data} onHide={_ => setDocModal({ showDocModal: false })} showPendingDocumentModal={docModal.showDocModal} />
            }
        </div>
    )
}